import { render, staticRenderFns } from "./region-statistic.vue?vue&type=template&id=6592b5f2&scoped=true&"
import script from "./region-statistic.vue?vue&type=script&lang=ts&"
export * from "./region-statistic.vue?vue&type=script&lang=ts&"
import style0 from "./region-statistic.vue?vue&type=style&index=0&id=6592b5f2&prod&scoped=true&lang=scss&"
import style1 from "./region-statistic.vue?vue&type=style&index=1&id=6592b5f2&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6592b5f2",
  null
  
)

export default component.exports